import React from 'react';
import AuthWrapper1 from './AuthWrapper1';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import CustomBackgroundComponent from '../../ui-components/CustomBackgroundComponent';
import { useTheme } from '@emotion/react';
import CustomInputField from '../../ui-components/CustomInputField';
import { Primary } from '../../ui-components/Buttons';
import { useNavigate } from 'react-router-dom';
import { LoginViaEmail, VerifyOTP } from '../../api';
import toast from 'react-hot-toast';
import CustomToast from '../../ui-components/CustomToast';
import Cookies from "js-cookie";
import loginLogo from '../../assets/login_account_tick.png';
import CustomHeaderIcon from '../../ui-components/CustomHeaderIcon';
import CustomValidationText from '../../ui-components/CustomValidationText';
import { useConfig } from '../../dynamic-configuration/configContext';
import { checkForDomain, findFirstTrueValue, setTokenForAuthorization, setUserType } from 'utils/index';

const OTP_GRADIENT = "linear-gradient(135deg, #7852f8 0%, #84aef8 100%)";

const inputProps = {
    maxLength: 1,
    inputMode: 'numeric',
    pattern: "[0-9]*",
    style: {
        textAlign: 'center',
        fontSize: '1.5rem',
        fontWeight: 600,
        padding: 0,
    },
    onKeyDown: (event) => {
        if (event.key === '-' || event.keyCode === 189) {
            event.preventDefault();
        }
    },
    onKeyPress: (event) => {
        const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
        if (!allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    },
    onInput: (event) => {
        const inputValue = event.target.value.replace(/[^0-9]/g, '');
        event.target.value = inputValue;
    }
};

const AuthOTPVerification = () => {

    const { config } = useConfig()
    const navigate = useNavigate();
    const theme = useTheme();
    const currentIP = window.location.host;
    const [error, setError] = React.useState(null)
    const [countDown, setCountDown] = React.useState(30);
    const [otpValues, setOtpValues] = React.useState(Array(4).fill(''));
    const inputRefs = [React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null)];
    const { mutateAsync: verifyOTPAsync, isLoading: isOTPLoading, data: verifyOtpResponse } = VerifyOTP();
    const { mutateAsync: reSendingOTPAsync, isLoading: isReSendingOTP } = LoginViaEmail();

    React.useEffect(() => {
        if (otpValues?.join("")?.trim()?.length > 0) {
            if (verifyOtpResponse?.data?.statusCode === 200) {
                setTimeout(() => {
                    setError(null)
                    const response = verifyOtpResponse?.data?.data;
                    // console.log(response, "response")
                    if (currentIP?.includes("localhost")) {
                        if (response?.user_id) {
                            Cookies.set("X-ADMIN-ID", response?.user_id);
                        }
                        response?.token && setTokenForAuthorization(response?.token);
                        // response?.token && setUserType("investor");
                    }
                    // response?.token && setUserType("investor");
                    // Session to be same for current users:
                    response?.token && setTokenForAuthorization(response?.token, checkForDomain());
                    // Cookies.set("step", Number(response?.step));
                    // console.log(response?.permissions, "response")
                    Boolean(response?.permissions) && Cookies.set("permissions", JSON.stringify(response?.permissions));
                    // const pathname = Cookies.get("pathname") || "/";

                    let pathname = "/"
                    // if (response?.permissions?.backrr_startups) {
                    //     pathname = "/backrr_startups"
                    // }
                    // else if (response?.permissions?.backrr_investors) {
                    //     pathname = "/backrr_investors"
                    // }
                    // else if (response?.permissions?.backrr_admin_settings_release_notes) {
                    //     pathname = "/admin_settings/release_notes"
                    // }
                    // else if (response?.permissions?.backrr_admin_settings_admin_users) {
                    //     pathname = "/admin_settings/admin_users"
                    // }


                    // const hasCollaborator = Boolean(response?.user_id);
                    // const hasInvestorId = Boolean(response?.investor_id);
                    // const claimedProfile = response?.claim_profile === true;
                    // const notClaimedAndNoInvestor = response?.claim_profile === false && !hasInvestorId;

                    // if (hasCollaborator) {
                    Cookies.set("X-ADMIN-ID", response?.user_id, { domain: checkForDomain() });
                    // Boolean(response?.is_profile_completed) && Cookies.set("is_profile_complete", response?.is_profile_completed);
                    navigate(pathname, { replace: true });
                    Cookies.remove("pathname");
                    // } 
                    // else if (claimedProfile && hasInvestorId) {
                    //     Cookies.set("X-ADMIN-TEMP-ID", response?.investor_id, { domain: checkForDomain() });
                    //     Boolean(response?.is_profile_completed) && Cookies.set("is_profile_complete", response?.is_profile_completed);
                    //     navigate("/activate-profile", { replace: true });
                    // } else if (notClaimedAndNoInvestor) {
                    //     navigate("/onboarding", { replace: true });
                    // } else {
                    //     Boolean(response?.is_profile_completed) && Cookies.set("is_profile_complete", response?.is_profile_completed);
                    //     setTimeout(() => {
                    //         navigate(response?.is_profile_completed ? pathname : "/onboarding", { replace: true });
                    //         Cookies.remove("pathname");
                    //     }, 10);
                    // }
                }, 100);
            } else if (verifyOtpResponse?.data?.statusCode !== 200) {
                // console.log(verifyOtpResponse?.data?.message, "co")
                verifyOtpResponse?.data?.message && setError(verifyOtpResponse?.data?.message || null)

            }
        }
    }, [verifyOtpResponse?.data?.statusCode, navigate]);

    const handleResendingOTP = () => {
        reSendingOTPAsync({
            email: Cookies.get("email"),
            devices: { device_token: `${Math.random() * 10}`, device_type: "web" },
            last_login_ip: `${currentIP}`,
            auth_provider: "email"
        }).then(() => {
            setCountDown(30);
        });
    };

    const handleInputChange = (event, index) => {
        const { value } = event.target;
        if (value.length === 1 && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
        const newOtpValues = [...otpValues];
        newOtpValues[index] = value;
        setOtpValues(newOtpValues);
        setError(null);
    };

    const handleKeyDown = (event, index) => {
        // Get the reference to the current input element
        // const currentRef = inputRefs[index];

        if (event.key === 'Backspace' && !event.target.value && index > 0) {
            inputRefs[index - 1].current.focus();
        }
        if (event.key === 'Enter') {
            handleVerifyOTP();
        }

        // Check if the arrow keys are pressed
        if (event.key === 'ArrowRight') {
            // Move focus to the next input if it's not the last one
            if (index < inputRefs.length - 1) {
                inputRefs[index + 1]?.current?.focus();
            }
        } else if (event.key === 'ArrowLeft') {
            // Move focus to the previous input if it's not the first one
            if (index > 0) {
                inputRefs[index - 1]?.current?.focus();
            }
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();

        // Get the pasted data and filter out non-numeric characters
        const pastedData = event.clipboardData
            .getData('text')
            .replace(/\D/g, '') // Remove all non-numeric characters
            .slice(0, 4); // Ensure only the first 4 characters are processed

        const newOtpValues = [...otpValues];

        pastedData.split('').forEach((char, index) => {
            if (inputRefs[index]) {
                inputRefs[index].current.value = char;
                newOtpValues[index] = char;
            }
        });

        setOtpValues(newOtpValues);
    };


    const handleVerifyOTP = () => {
        const OTP = otpValues.join('');
        if (OTP?.trim()?.length > 0) { verifyOTPAsync({ email: Cookies.get("email"), otp: OTP }); }
        else {
            setError(config?.validationFields?.otp?.error);
        }
    };

    React.useEffect(() => {
        inputRefs[0].current.focus();
    }, []);

    React.useEffect(() => {
        if (countDown > 0) {
            const timer = setTimeout(() => setCountDown(prev => prev - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countDown]);

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="15.9" y="20.9" width="32.2" height="22.2" rx="2.1" fill="white" stroke="url(#paint0_linear_8_333)" strokeWidth="1.8" />
                    <path d="M15 22L32 33L49 22" stroke="url(#paint1_linear_8_333)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    <rect x="0.5" y="0.5" width="63" height="63" rx="11.5" stroke="url(#paint2_linear_8_333)" />
                    <defs>
                        <linearGradient id="paint0_linear_8_333" x1="15" y1="32" x2="49" y2="32" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#7852F8" />
                            <stop offset="1" stopColor="#84AEF6" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_8_333" x1="15" y1="27.5" x2="49" y2="27.5" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#7852F8" />
                            <stop offset="1" stopColor="#84AEF6" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_8_333" x1="32" y1="0" x2="32" y2="64" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#7852F8" />
                            <stop offset="1" stopColor="#84AEF6" />
                        </linearGradient>
                    </defs>
                </svg>
            </Box>
            <Typography sx={{
                fontSize: { xs: "1.75rem", sm: "2rem" }, fontWeight: 700, color: "#101828", textAlign: "center",
                lineHeight: 1.2
            }}>
                Verify with OTP
            </Typography>
            <Typography sx={{ color: "#667085", textAlign: "center", mt: 1, fontSize: "1rem" }}>
                We have sent you an OTP on
            </Typography>
            <Typography sx={{ color: "#101828", fontWeight: 600, textAlign: "center", fontSize: "1rem", wordBreak: "break-word" }}>
                {Cookies.get("email")}
            </Typography>

            <Typography sx={{ color: "#344054", fontWeight: 500, fontSize: "0.875rem", mt: 3, mb: 1 }}>
                Enter OTP
            </Typography>
            <Grid container xs={12} gap={{ xs: 1.5, sm: 2 }} flexWrap="nowrap">
                {inputRefs.map((ref, index) => (
                    <Grid item flex={1} key={index}>
                        <CustomInputField
                            inputProps={inputProps}
                            required
                            sx={{
                                marginBottom: 0,
                                "& .MuiFilledInput-root": {
                                    height: { xs: "60px" },
                                    borderRadius: "12px",
                                    alignItems: "center",
                                },
                                "& .MuiFilledInput-root.Mui-focused": {
                                    borderColor: "#101828",
                                    borderWidth: "1.5px",
                                },
                                "& .MuiFilledInput-input": { height: "100%", padding: 0 },
                            }}
                            inputRef={ref}
                            onChange={(event) => handleInputChange(event, index)}
                            onKeyDown={(event) => handleKeyDown(event, index)}
                            onPaste={index === 0 ? handlePaste : undefined}
                        />
                    </Grid>
                ))}
            </Grid>
            {error !== null && <span style={{
                color: "rgb(239, 83, 80)",
                fontWeight: "400",
                fontSize: "0.75rem",
                lineHeight: "1.66",
                letterSpacing: "0.03333em",
                textAlign: "left",
                marginTop: "8px",
                marginBottom: "0",
            }}>{error}</span>}
            {isReSendingOTP ? (
                <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2, color: "#101828" }} fontSize="0.95rem">
                    <CircularProgress sx={{ color: "#6D3DF0" }} size="1rem" /> <span>Resending OTP</span>
                </Typography>
            ) : (
                <Typography sx={{ mt: 2, fontSize: "0.95rem" }}>
                    <Box
                        component="span"
                        onClick={countDown === 0 ? handleResendingOTP : undefined}
                        sx={{ color: "#101828", fontWeight: 500, cursor: countDown > 0 ? "default" : "pointer" }}
                    >
                        Resend OTP
                    </Box>
                    {countDown > 0 && <Box component="span" sx={{ color: "#667085" }}>&nbsp;({countDown} Sec)</Box>}
                </Typography>
            )}
            <Primary
                disabled={isOTPLoading}
                sx={{ background: OTP_GRADIENT, borderRadius: "10px", textTransform: "none", height: "54px", fontSize: "1rem", fontWeight: 600, boxShadow: "none", mt: 3, "&:hover": { background: OTP_GRADIENT, boxShadow: "none" }, "&.Mui-disabled": { color: "#ffffff", opacity: 0.7 } }}
                fullWidth
                onClick={handleVerifyOTP}
            >
                {isOTPLoading ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size="1.4rem" /> : "Verify OTP"}
            </Primary>
        </Box>
    );
}

export default AuthOTPVerification;
